(() => {
  const head = document.querySelector('.template-search .template-search__header');
  if (!head || head.dataset.bzSr) return;
  head.dataset.bzSr = 'true';

  const params = new URLSearchParams(location.search);
  const query = (params.get('q') || '').trim();
  const countEl = document.getElementById('ProductCount') || document.querySelector('.product-count__text');
  const grid = document.querySelector('#product-grid .product-grid');
  const items = grid ? grid.querySelectorAll(':scope > li').length : 0;
  const countText = countEl ? countEl.textContent.trim() : '';
  const total = parseInt(countText, 10);
  /* Count what is actually shown (the theme count can include items that are not listed) */
  const found = items && items < 24 ? items : Number.isFinite(total) ? total : items;
  if (countEl && items && items < 24 && found !== total) {
    countEl.textContent = found + (found === 1 ? ' result' : ' results');
  }

  const h1 = head.querySelector('h1');
  if (h1) {
    const eyebrow = document.createElement('p');
    eyebrow.className = 'bz-sr-eyebrow';
    eyebrow.textContent = 'BEZELOR search';
    h1.before(eyebrow);
    h1.classList.add('bz-sr-title');
    h1.textContent = '';
    if (query) {
      h1.append('Results for ');
      const em = document.createElement('em');
      em.textContent = '“' + query + '”';
      h1.append(em);
    } else {
      h1.textContent = 'Find your next watch';
    }
    const sub = document.createElement('p');
    sub.className = 'bz-sr-sub';
    sub.textContent = query
      ? found > 0
        ? found + (found === 1 ? ' watch matches your search' : ' watches match your search')
        : 'No exact matches. Try a brand, model number or style, or search with a photo.'
      : 'Search by brand, model number or style, or upload a photo of a watch you like.';
    h1.after(sub);
  }

  /* Search with a photo: opens the search panel and the photo picker */
  const box = head.querySelector('.template-search__search');
  const opener = document.querySelector('[data-bz-search-open]');
  const camera = document.querySelector('[data-bz-camera]');
  if (box && opener && camera) {
    const photo = document.createElement('button');
    photo.type = 'button';
    photo.className = 'bz-sr-photo';
    photo.setAttribute('aria-label', 'Search with a photo');
    photo.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2l1.4-2h6.2l1.4 2h2A1.5 1.5 0 0 1 20 8.5v9A1.5 1.5 0 0 1 18.5 19h-13A1.5 1.5 0 0 1 4 17.5z"/><circle cx="12" cy="12.8" r="3.4"/></svg><span>Search with a photo</span>';
    photo.addEventListener('click', () => {
      opener.click();
      camera.click();
    });
    box.append(photo);
  }

  /* Popular searches */
  const chips = document.createElement('div');
  chips.className = 'bz-sr-chips';
  chips.innerHTML = '<span>Popular:</span>';
  [
    ['Automatic', '/collections/automatic-watches'],
    ['Chronograph', '/collections/chronograph-watches'],
    ['Men’s', '/collections/mens-watches'],
    ['Women’s', '/collections/womens-watches'],
    ['Couple', '/collections/couple-watches'],
    ['New arrivals', '/collections/new-arrivals'],
  ].forEach(([label, url]) => {
    const a = document.createElement('a');
    a.href = url;
    a.textContent = label;
    chips.append(a);
  });
  head.append(chips);

  /* Friendly empty state */
  if (query && found === 0 && !items) {
    const container = document.getElementById('ProductGridContainer');
    const empty = document.createElement('div');
    empty.className = 'bz-sr-empty';
    empty.innerHTML =
      '<h2>Nothing found yet</h2><p>Check the spelling, try a shorter term, or browse everything we have.</p><a href="/collections/all">Browse all watches</a>';
    if (container) container.prepend(empty);
    else head.after(empty);
  }
})();